<template>
  <makc-header v-if="routeCheck"/>
  <div :class="routeCheck ? 'divider' : ''">
    <router-view/>
  </div>
  <!-- <makc-footer/> -->
</template>

<script>
import MakcHeader from '@/create/components/MakcHeader.vue';
// import MakcFooter from '@/create/components/MakcFooter.vue';

export default {
  components: {MakcHeader, /*MakcFooter*/},
  computed: {
    routeCheck() { // в лендинге (component: FinalPage) отключаем верхнее меню и прилегающий класс divider
      if (this.$route.params.slugID || this.$route?.name?.includes('landing')) {
        return false
      } else {
        return true
      }
    }
  },
}
</script>

<style lang="scss">

@import "@/create/assets/scss/style.scss";

.divider {
  position: relative;
  top: 110px;
}
</style>
